import React from 'react'

const Errors = props => {

  let { errors } = props

  const errorList = errors && errors.response.data.errors ?
    (
      <ul className={'form-error'}>
        {Object.keys(errors.response.data.errors).map(error => {
          return <li className="form-error__li" key={error}>{ errors.response.data.errors[error][0] }</li>
        })}
      </ul>
    ) : null

  return (
    <>
      {errorList}
    </>
  )
}

export default Errors
